export const ROOT_KEY = 'ROOT';
export const PERSONAL_ROOT_KEY = 'PERSONAL_ROOT';
export const SEARCH_KEY = 'SEARCH';

export enum Filters {
  RECENT = 'recents',
  FAVORITES = 'favorites',
  TRASH = 'trash',
}
